import axiosConfig from '../utils/axiosConfigInstance';

export const respondToTrcRequest = async payload => {
	const url = `/admin/trc/users/response`;
	return await axiosConfig.post(url, payload);
};

export const deleteTrcContentApi = async payload => {
	const url = `/trc/content/${payload.id}`;
	return await axiosConfig.delete(url);
};

export const createTrcContentApi = async payload => {
	const url = `/admin/trc/upload/content`;
	return await axiosConfig.post(url, payload);
};

export const updateTrcContentApi = async (id, payload) => {
	const url = `/trc/content/${id}`;
	return await axiosConfig.put(url, payload);
};